import React 			from 'react';
import ReactDOM 		from 'react-dom';
import BLComponent 		from '../core/_BLComponent.jsx';

import PageBreadcrumbs 		from '../common/_PageBreadcrumbs.jsx';
import ProductInventoryListingItem	from '../common/_ProductInventoryListingItem.jsx';
import CustomCheckbox 		from '../common/_CustomCheckbox.jsx';
import InputSwitch 				from '../common/_InputSwitch.jsx';
import ItemOverview 		from './_ItemOverview.jsx';
import LazyLoad 		from '../common/_LazyLoad.jsx';

import AddToWantedListModal		from "../modals/_AddToWantedListModal.jsx";
import EasyBuyModal				from "../modals/_EasyBuyModal.jsx";


export default class ItemInventoryPage extends BLComponent
{
	constructor(props) 
	{
		super(props);

		this.itemData	= blapp.models.get( "itemInfo" );
		this.invData	= blapp.models.get( "invInfo" );

		this.buildInfo(false);

		this.itemsPerPage = 100;

		this.state = 
			{
				dummy:					0
			,	partOpen: 				true
			,	minifigOpen:			true
			,	setOpen:				true
			,	alternatesOpen:			true
			,	counterpartsOpen:		true
			,	extrasOpen:				true
			,	showAddToWantedList:	false
			,	showEasyBuy:			false
			,	hasMore: true
			,	loadingMore: false
			,	page: 1
			,	sortDirection: 1
			,	sortType: 0
			,	showAlternate:			false
			,	breakMinifigs:			false
			,	breakSets:				false
			};
	}

	componentDidMount() {
		this.initStickyEditBar()
	}

	componentDidUpdate(prevProps, prevState) {
		const hasMore = this.invParts.length > this.state.page * this.itemsPerPage;

		if(prevState.page != this.state.page) {
			this.setState({hasMore: hasMore});
		}
	}

	buildInfo(bRefresh)
	{
		if ( this.invData )
		{
			this.invParts		= [];
			this.invMinifigs	= [];
			this.invSets		= [];
			this.invAlternates	= [];
			this.invCounterparts	= [];
			this.invExtras		= [];
			_.forEach(
				this.invData
			,	( inv, idx ) =>
				{
					inv._idx		= idx;
					inv._isSelected	= false;
					if ( inv.typeInv == "R" && inv.dmItem.dmItem.typeItem == "P" )
						this.invParts.push( inv );
					else if ( inv.typeInv == "R" && inv.dmItem.dmItem.typeItem == "M" )
						this.invMinifigs.push( inv );
					else if ( inv.typeInv == "R" && inv.dmItem.dmItem.typeItem == "S" )
						this.invSets.push( inv );
					else if ( inv.typeInv == "A" )
						this.invAlternates.push( inv );	
					else if ( inv.typeInv == "C" )
						this.invCounterparts.push( inv );	
					else if ( inv.typeInv == "E" )
						this.invExtras.push( inv );					
				}	
			);
		}

		this.summary = {
			sLots: this.invSets.length
		,	sQty: this.invSets.reduce(function(acc,inv){return acc+inv.nQty}, 0)
		,	mLots: this.invMinifigs.length
		,	mQty: this.invMinifigs.reduce(function(acc,inv){return acc+inv.nQty}, 0)
		,	pLots: this.invParts.length
		,	pQty: this.invParts.reduce(function(acc,inv){return acc+inv.nQty}, 0)
		,	epLots: this.invExtras.length
		,	epQty: this.invExtras.reduce(function(acc,inv){return acc+inv.nQty}, 0)
		,	cpLots: this.invCounterparts.length
		,	cpQty: this.invCounterparts.reduce(function(acc,inv){return acc+inv.nQty}, 0)
		,	aLots: this.invAlternates.length
		,	aQty: this.invAlternates.reduce(function(acc,inv){return acc+inv.nQty}, 0)
		}

		if(bRefresh)
			this.setState({dummy: this.state.dummy + 1})
	}

	buildRenderData()
	{
		let	pCnt			= 0;
		let	mCnt			= 0;
		let	sCnt			= 0;
		let	aCnt			= 0;
		let	cCnt			= 0;
		let	eCnt			= 0;
		let	view			= null;
		let	selectedCnt		= 0;
		let	isAllSelected	= false;

		_.forEach( 
			this.invParts
		, 	( inv ) => 
			{ 
				if ( inv._isSelected )
					++pCnt;
			}
		);

		_.forEach( 
			this.invMinifigs
		, 	( inv ) => 
			{ 
				if ( inv._isSelected )
					++mCnt;
			}
		);

		_.forEach( 
			this.invSets
		, 	( inv ) => 
			{ 
				if ( inv._isSelected )
					++sCnt;
			}
		);	
		
		_.forEach( 
			this.invAlternates
		, 	( inv ) => 
			{ 
				if ( inv._isSelected )
					++aCnt;
			}
		);	

		_.forEach( 
			this.invCounterparts
		, 	( inv ) => 
			{ 
				if ( inv._isSelected )
					++cCnt;
			}
		);	

		_.forEach( 
			this.invExtras
		, 	( inv ) => 
			{ 
				if ( inv._isSelected )
					++eCnt;
			}
		);	


		view		= this.invData;
		selectedCnt	= pCnt + mCnt + sCnt + aCnt + cCnt + eCnt;

		this.renderData	= { pCnt: pCnt, mCnt: mCnt, sCnt: sCnt, aCnt: aCnt, cCnt: cCnt, eCnt: eCnt, view: view, selectedCnt: selectedCnt, isAllSelected: selectedCnt == view.length };
	}


	render() 
	{
		if ( this.itemData == null || this.invData == null )
		{
			return (
				<div className="main main--white">
					<div className="l-pad--xxl text--center">
						{$T("DATA_NOT_FOUND")}
					</div>
				</div>
			);
		}
		
		this.buildRenderData();

		let	idColor	= blapp.util.getUrlVar( "idColor" );
		const counts = this.summary;
		const credits = this.buildCredits();

		let typeBreak = 0;
		if( this.state.breakMinifigs && !this.state.breakSets )
			typeBreak = 1;
		else if( !this.state.breakMinifigs && this.state.breakSets )
			typeBreak = 2
		else if( this.state.breakMinifigs && this.state.breakSets )
			typeBreak = 3

		return (
			<div className="main main--white">
				<div className="main__content main__content--tight-mob">
					<header className="store-listings__head">
						<a className="l-block store-listings__head-back" href={blapp.url2.getCatalogItemPageUrl( this.itemData.dmItemDetail.dmItem.dmBasic, idColor )}><i className="fas fa-long-arrow-left l-margin-right--sm"/>{$T("BACK_TO_ITEM_DETAILS")}</a>
						<h1 className="pdp__header-title">{this.itemData.dmItemDetail.dmItem.dmBasic.strItemName} <span className="l-hide--small">{$T("CONSISTS_OF")}</span></h1>
						<p className="l-hide--desktop">Item no: {this.itemData.dmItemDetail.dmItem.dmBasic.strItemNoFull}</p>
					</header>
					
					<div className="mdc-layout-grid l-pad-null store-listings__grid">
						<div className="mdc-layout-grid__inner">
							<div className="mdc-layout-grid__cell mdc-layout-grid__cell--span-8-desktop mdc-layout-grid__cell--span-9-desktop-l mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
								{this.renderFilter()}
								
								{this.renderData.selectedCnt > 0 ? this.renderStickyFooter() : null}
								{this.renderInventoryGroups()}
								{credits.length ? 
									<div className="l-pad l-hide--desktop">
										<h2 className="text--small-title text--bold l-margin-bottom">Credits</h2>
										{credits.map((credit, key) => <p key={key} dangerouslySetInnerHTML={{__html: credit}}></p>)}
									</div>
								: null}
							</div>
							<div ref={sidebar => this.sidebar = sidebar} className="item-overview-sidebar item-overview-sidebar--inventory mdc-layout-grid__cell mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-3-desktop-l mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
								<ItemOverview item={this.itemData}>{this.renderOverviewContent()}</ItemOverview>
								<a className="btn l-full-width l-hide--small l-block l-margin-top--xl text-color--black" href={blapp.url2.getCatalogItemInventoryPrintUrl(this.itemData.dmItemDetail.dmItem.dmBasic, idColor, typeBreak, this.state.sortType, this.state.sortDirection)} target="_blank"><i className="far fa-print l-margin-right--sm"/>Printer-friendly version</a>
							</div>
						</div>
					</div>
				</div>
				{ this.state.showAddToWantedList ? this.renderAddToWantedList() : null }
				{ this.state.showEasyBuy ? this.renderEasyBuy() : null }
			</div>
		);
	}

	renderFilter() {
		const hasSets = this.invSets.length;
		const hasMinifigs = this.invMinifigs.length;
		
		return (
			<div className={"product-inventory__filter-bar " + (this.renderData.isAllSelected ? ' l-border--bottom' : '')}>
				<h3 className="product-inventory__filter-bar-title">View options</h3>
				<label className="l-flex l-center l-hide--small">
					<CustomCheckbox isDark isChecked={this.renderData.isAllSelected} isIndeterminate={this.renderData.selectedCnt > 0 && this.renderData.selectedCnt < this.invData.length } onChangeFunc={() => this.toggleAllOfAll()} classes="l-margin-right"/>
					Select all items
				</label>
				
				<div className="product-inventory__filter-bar-options">
					{ ( hasMinifigs || this.state.breakMinifigs ) || ( hasSets || this.state.breakSets ) ? 


					<div className="product-inventory__filter-option-group ">
						<span className="l-margin-right--sm product-inventory__filter-option-group-label">Break:</span>
						{hasMinifigs || this.state.breakMinifigs ?
							<label className="l-flex l-center">
								<CustomCheckbox isDark isChecked={this.state.breakMinifigs} onChangeFunc={() => this.breakItems('minifigs')} classes="l-margin-right--sm"/>
								Minifigures
							</label>
						: null}
						{hasSets || this.state.breakSets ? 
							<label className="l-flex l-center l-margin-left">
								<CustomCheckbox isDark isChecked={this.state.breakSets} onChangeFunc={() => this.breakItems('sets')} classes="l-margin-right--sm"/>
								Sets
							</label>
						: null}
					</div>
					:null}
					<div className="product-inventory__filter-option-group product-inventory__filter-option-group--alternate">
						<span className=" product-inventory__filter-option-group-label text--no-wrap">Alternate items:</span>
						<label className="l-flex l-center l-margin-left--sm">
							<strong>{this.renderData.showAlternate ? 'Hide' : 'Show'}</strong>
							<InputSwitch isChecked={this.state.showAlternate} onClickFunc={() => this.toggleAlternate()} classes="l-margin-left--sm"/>
						</label>
					</div>
					<div className="product-inventory__filter-option-group">
						<label htmlFor="filter" className="l-margin-right--sm text--no-wrap l-hide--small">{$T("SORT_BY")}</label>
						<div className="sort-lockup sort-lockup--thick product-inventory__filter-sort">
							<button className="btn sort-lockup__direction" onClick={() => this.toggleSortDirection()}>
								<i className={"fas " + (this.state.sortDirection == -1 ? 'fa-sort-amount-down' : 'fa-sort-amount-up')}/>
							</button>
							<select className="select sort-lockup__select" value={this.state.sortType} onChange={(e) => this.updateSortType( e.target.value )}>
								{ _.map( [ 0, 1, 2, 3, 4 ], ( i ) => <option key={i} value={i}>{this.getSortOrderInfo(i)}</option> ) }
							</select>
						</div>
					</div>
				</div>
				<div className="product-inventory__filter-bar-mobile-options">
					<h3 className="product-inventory__filter-bar-title">Items</h3>
					<button className={"l-full-width btn" + (this.renderData.isAllSelected ? " btn--cta" : "")} onClick={() => this.toggleAllOfAll()}>{this.renderData.isAllSelected ? 'Deselect all' : 'Select all'}</button>
				</div>
			</div>
		);
	}

	renderOverviewContent() {
		const counts = this.summary;
		const credits = this.buildCredits();

		return (
			<div>
				<h2 className="l-hide--small text--small-title text--bold l-margin-bottom">Summary</h2>
				<h2 className="l-hide--desktop text--small-title text--bold l-margin-bottom">This set consists of</h2>
				<div className="flex-table flex-table--edge-to-edge">
					<div className="flex-table__header flex-table__header--clean l-border--bottom l-border--thick">
						<div className="flex-table__cell flex-table__cell--40 text--uppercase">Type</div>
						<div className="flex-table__cell flex-table__cell--25 text--uppercase flex-table__cell--align-right">Lots</div>
						<div className="flex-table__cell flex-table__cell--35 text--uppercase flex-table__cell--align-right">Total qty</div>
					</div>
					{	// XP-783 
						(counts.sQty > 0) ?
						<div className="flex-table__row">
							<div className="flex-table__cell flex-table__cell--40"><a href="#Sets">Sets</a></div>
							<div className="flex-table__cell flex-table__cell--25 flex-table__cell--align-right">{counts.sLots}</div>
							<div className="flex-table__cell flex-table__cell--35 flex-table__cell--align-right">{counts.sQty}</div>
						</div>
						:null 
					}

					<div className="flex-table__row">
						<div className="flex-table__cell flex-table__cell--40"><a href="#Minifigs">Minifigures</a></div>
						<div className="flex-table__cell flex-table__cell--25 flex-table__cell--align-right">{counts.mLots}</div>
						<div className="flex-table__cell flex-table__cell--35 flex-table__cell--align-right">{counts.mQty}</div>
					</div>
					<div className="flex-table__row">
						<div className="flex-table__cell flex-table__cell--40"><a href="#Parts">Parts</a></div>
						<div className="flex-table__cell flex-table__cell--25 flex-table__cell--align-right">{counts.pLots}</div>
						<div className="flex-table__cell flex-table__cell--35 flex-table__cell--align-right">{counts.pQty}</div>
					</div>
					<div className="flex-table__row">
						<div className="flex-table__cell flex-table__cell--40"><a href="#ExtraParts">Extra parts</a></div>
						<div className="flex-table__cell flex-table__cell--25 flex-table__cell--align-right">{counts.epLots}</div>
						<div className="flex-table__cell flex-table__cell--35 flex-table__cell--align-right">{counts.epQty}</div>
					</div>
					<div className="flex-table__row">
						<div className="flex-table__cell flex-table__cell--40"><a href="#CounterParts">Counterparts</a></div>
						<div className="flex-table__cell flex-table__cell--25 flex-table__cell--align-right">{counts.cpLots}</div>
						<div className="flex-table__cell flex-table__cell--35 flex-table__cell--align-right">{counts.cpQty}</div>
					</div>
					<div className="flex-table__row">
						<div className="flex-table__cell flex-table__cell--40"><a href="#Alternates">Alt. parts</a></div>
						<div className="flex-table__cell flex-table__cell--25 flex-table__cell--align-right">{counts.aLots}</div>
						<div className="flex-table__cell flex-table__cell--35 flex-table__cell--align-right">{counts.aQty}</div>
					</div>
				</div>
				{credits.length ? 
					<div className="l-margin-top--xl l-hide--small">
						<h2 className="text--small-title text--bold l-margin-bottom">Credits</h2>
						{credits.map((credit, key) => <p key={key} dangerouslySetInnerHTML={{__html: credit}}></p>)}
					</div>
				: null}
			</div>
		);
	}

	buildCredits()
	{
		const cr = this.itemData.dmItemDetail.invCredits;
		const cc = this.itemData.dmItemDetail.invConfirmCredits;
		let credits = [];
		if(cr == null && cc == null) return credits;

		if (cr != null && cr.dmUserInventory && cr.tsInventoried)
		{
			let c1 = `<span class="text-color--primaryBlue">${cr.dmUserInventory.skUsername}</span> inventoried this ${blapp.util.getTypeName(this.itemData.dmItemDetail.dmItem.dmBasic.typeItem)} on ${blapp.format.formatDate(cr.tsInventoried)}`;
			if(cr.tsInvUpdated)
				c1 += `, inventory last updated on ${blapp.format.formatDate(cr.tsInvUpdated)}.`;
			credits.push(c1);
		}

		if( cc != null)
		{
			cc.forEach( c =>{
				if(c.dmUserConfirmInventory && c.tsConfirmInventory)
				{
					let c2 = `<span class="text-color--primaryBlue">${c.dmUserConfirmInventory.skUsername}</span> confirmed accuracy of this inventory on ${blapp.format.formatDate(c.tsConfirmInventory)}.`;
					if(c.strConfirmInventoryText)
						c2 += ` (source: ${c.strConfirmInventoryText})`;
					credits.push(c2);
				}
			})
		}
		

		return credits;
	}

	renderInventoryGroups() 
	{
		const parts	= [...this.invParts];
		const sets	= [...this.invSets];
		const minifigs	= [...this.invMinifigs];
		const alternates = [...this.invAlternates];
		const counterparts = [...this.invCounterparts];
		const extras = [...this.invExtras];

		const pItems 	= 	parts.sort(this.sortBy).map(
								(inv, key) => 
									<ProductInventoryListingItem
										showAlternate={this.state.showAlternate}
										data={ProductInventoryListingItem.getDataFromItemInv( inv, true )} 
										alternates={this.getAlternates(inv, 0)}
										select={
												{
													enabled:		true
												,	isChecked: 		inv._isSelected
												,	onChangeFunc: 	() => this.toggleInventorySelection( inv._idx )
												}
											}
									/>
							);

		const mItems 	=	minifigs.sort(this.sortBy).map(
								(inv, key) => 
									<ProductInventoryListingItem
										showAlternate={this.state.showAlternate}
										data={ProductInventoryListingItem.getDataFromItemInv( inv )} 
										alternates={this.getAlternates(inv, 0)}
										select={
												{
													enabled:		true
												,	isChecked: 		inv._isSelected
												,	onChangeFunc: 	() => this.toggleInventorySelection( inv._idx )
												}
											}
									/>
							);

		const sItems 	=	sets.sort(this.sortBy).map(
								(inv, key) => 
									<ProductInventoryListingItem
										showAlternate={this.state.showAlternate}
										data={ProductInventoryListingItem.getDataFromItemInv( inv )} 
										alternates={this.getAlternates(inv, 0)}
										select={
												{
													enabled:		true
												,	isChecked: 		inv._isSelected
												,	onChangeFunc: 	() => this.toggleInventorySelection( inv._idx )
												}
											}
									/>
							);

		const aItems 	=	alternates.sort(this.sortBy).map(
								(inv, key) => 
									<ProductInventoryListingItem
										showAlternate={this.state.showAlternate}
										data={ProductInventoryListingItem.getDataFromItemInv( inv, true )} 
										alternates={this.getAlternates(inv, 1)}
										isAlternate={true}
										select={
												{
													enabled:		true
												,	isChecked: 		inv._isSelected
												,	onChangeFunc: 	() => this.toggleInventorySelection( inv._idx )
												}
											}
									/>
							);				

		const cItems 	= 	counterparts.sort(this.sortBy).map(
								(inv, key) => 
									<ProductInventoryListingItem
										showAlternate={this.state.showAlternate}
										data={ProductInventoryListingItem.getDataFromItemInv( inv, true )} 
										alternates={this.getAlternates(inv, 0)}
										select={
												{
													enabled:		true
												,	isChecked: 		inv._isSelected
												,	onChangeFunc: 	() => this.toggleInventorySelection( inv._idx )
												}
											}
									/>
							);

		const eItems 	= 	extras.sort(this.sortBy).map(
								(inv, key) => 
									<ProductInventoryListingItem
										showAlternate={this.state.showAlternate}
										data={ProductInventoryListingItem.getDataFromItemInv( inv, true )} 
										alternates={this.getAlternates(inv, 0)}
										select={
												{
													enabled:		true
												,	isChecked: 		inv._isSelected
												,	onChangeFunc: 	() => this.toggleInventorySelection( inv._idx )
												}
											}
									/>
							);

		return (
			<div className="checkbox-drawer">
				{
					sItems.length > 0  ?
					<section className="checkbox-drawer__section" id="Sets"> 
						<div className="checkbox-drawer__header">
							<CustomCheckbox classes="l-margin-right" isChecked={ ( this.renderData.sCnt == sItems.length ) } isIndeterminate={ this.renderData.sCnt > 0 && this.renderData.sCnt < sItems.length } onChangeFunc={() => this.toggleAll('set')}/>
							<button className="btn btn--blank l-full-width l-flex l-split l-center" onClick={() => this.setState({setOpen: !this.state.setOpen})}><span>{$T("SETS")} ({sItems.length})</span><i className={'l-margin-left--sm fas ' + (this.state.setOpen ? 'fa-chevron-down' : 'fa-chevron-up')}/></button>
						</div>
						{
							this.state.setOpen ? 
							<div className="checkbox-drawer__drawer l-pad--null">
								{this.returnTableHeader()}
								{sItems}
							</div>
							: 
							null
						}
					</section>
					: 
					null
				}			
				{
					mItems.length > 0  ?
					<section className="checkbox-drawer__section" id="Minifigs"> 
						<div className="checkbox-drawer__header">
							<CustomCheckbox classes="l-margin-right" isChecked={ ( this.renderData.mCnt == mItems.length ) } isIndeterminate={ this.renderData.mCnt > 0 && this.renderData.mCnt < mItems.length } onChangeFunc={() => this.toggleAll('minifig')}/>
							<button className="btn btn--blank l-full-width l-flex l-split l-center" onClick={() => this.setState({minifigOpen: !this.state.minifigOpen})}><span>{$T("MINIFIGS")} ({mItems.length})</span><i className={'l-margin-left--sm fas ' + (this.state.minifigOpen ? 'fa-chevron-down' : 'fa-chevron-up')}/></button>
						</div>
						{
							this.state.minifigOpen ? 
							<div className="checkbox-drawer__drawer l-pad--null">
								{this.returnTableHeader()}
								{mItems}
							</div>
							: 
							null
						}
					</section>
					: 
					null
				}			
				{	
					pItems.length > 0  ?
					<section className="checkbox-drawer__section" id="Parts"> 
						<div className="checkbox-drawer__header">
							<CustomCheckbox classes="l-margin-right" isChecked={ ( this.renderData.pCnt == pItems.length )} isIndeterminate={ this.renderData.pCnt > 0 && this.renderData.pCnt < pItems.length } onChangeFunc={() => this.toggleAll('part')}/> 
							<button className="btn btn--blank l-full-width l-flex l-split l-center" onClick={() => this.setState({partOpen: !this.state.partOpen})}><span>{$T("PARTS")} ({pItems.length})</span><i className={'l-margin-left--sm fas ' + (this.state.partOpen ? 'fa-chevron-down' : 'fa-chevron-up')}/></button>
						</div>
						{
							this.state.partOpen ? 
							<div className="checkbox-drawer__drawer l-pad--null">
								{this.returnTableHeader()}
								{pItems.splice(0, this.state.page * this.itemsPerPage)}
								{this.state.hasMore && <LazyLoad disable={this.state.loadingMore == true} callbackFunc={() => this.loadMore()}/>}
							</div>
							: 
							null
						}
					</section>
					: null
				}

				{	
					aItems.length > 0  ?
					<section className="checkbox-drawer__section" id="Alternates"> 
						<div className="checkbox-drawer__header">
							<CustomCheckbox classes="l-margin-right" isChecked={ ( this.renderData.aCnt == aItems.length )} isIndeterminate={ this.renderData.aCnt > 0 && this.renderData.aCnt < aItems.length } onChangeFunc={() => this.toggleAll('alternates')}/> 
							<button className="btn btn--blank l-full-width l-flex l-split l-center" onClick={() => this.setState({alternatesOpen: !this.state.alternatesOpen})}><span>Alternate items ({aItems.length})</span><i className={'l-margin-left--sm fas ' + (this.state.alternatesOpen ? 'fa-chevron-down' : 'fa-chevron-up')}/></button>
						</div>
						{
							this.state.alternatesOpen ? 
							<div className="checkbox-drawer__drawer l-pad--null">
								{this.returnTableHeader()}
								{aItems}
							</div>
							: 
							null
						}
					</section>
					: null
				}

				{	
					cItems.length > 0  ?
					<section className="checkbox-drawer__section" id="CounterParts"> 
						<div className="checkbox-drawer__header">
							<CustomCheckbox classes="l-margin-right" isChecked={ ( this.renderData.aCnt == cItems.length )} isIndeterminate={ this.renderData.cCnt > 0 && this.renderData.cCnt < cItems.length } onChangeFunc={() => this.toggleAll('counterparts')}/> 
							<button className="btn btn--blank l-full-width l-flex l-split l-center" onClick={() => this.setState({counterpartsOpen: !this.state.counterpartsOpen})}><span>Counterpart items ({cItems.length})</span><i className={'l-margin-left--sm fas ' + (this.state.counterpartsOpen ? 'fa-chevron-down' : 'fa-chevron-up')}/></button>
						</div>
						{
							this.state.counterpartsOpen ? 
							<div className="checkbox-drawer__drawer l-pad--null">
								{this.returnTableHeader()}
								{cItems}
							</div>
							: 
							null
						}
					</section>
					: null
				}

				{	
					eItems.length > 0  ?
					<section className="checkbox-drawer__section" id="ExtraParts"> 
						<div className="checkbox-drawer__header">
							<CustomCheckbox classes="l-margin-right" isChecked={ ( this.renderData.eCnt == eItems.length )} isIndeterminate={ this.renderData.eCnt > 0 && this.renderData.eCnt < eItems.length } onChangeFunc={() => this.toggleAll('extras')}/> 
							<button className="btn btn--blank l-full-width l-flex l-split l-center" onClick={() => this.setState({extrasOpen: !this.state.extrasOpen})}><span>Extra items ({eItems.length})</span><i className={'l-margin-left--sm fas ' + (this.state.extrasOpen ? 'fa-chevron-down' : 'fa-chevron-up')}/></button>
						</div>
						{
							this.state.extrasOpen ? 
							<div className="checkbox-drawer__drawer l-pad--null">
								{this.returnTableHeader()}
								{eItems}
							</div>
							: 
							null
						}
					</section>
					: null
				}

			</div>
		);
	}

	returnTableHeader() {
		return (
			<div className="flex-table__header product-inventory__table-header">
				<div className="flex-table__cell flex-table__cell--5"></div>
				<div className="flex-table__cell flex-table__cell--20"></div>
				<div className="flex-table__cell flex-table__cell--5">Qty</div>
				<div className="flex-table__cell flex-table__cell--40">Description</div>
				<div className="flex-table__cell flex-table__cell--10">Item no.</div>
				<div className="flex-table__cell flex-table__cell--10"><span className="product-inventory__table-label--small">Inv. ID</span><span className="product-inventory__table-label--large">Inventory ID</span></div>
				<div className="flex-table__cell flex-table__cell--10 flex-table__cell--align-right l-pad-right"><span className="product-inventory__table-label--small">MID</span><span className="product-inventory__table-label--large">Match ID</span><i className="fas fa-info-circle l-margin-left--xs"/></div>
			</div>
		);
	}

	renderAddToWantedList()
	{
		const	itemBasic	= 	this.itemData.dmItemDetail.dmItem.dmBasic;
		let		addItems	= 	[];
		let		smi			=	{
									location:		blapp.srcmap.LOCATION.CATALOG_CONSISTS_OF_XP
								,	typeSrcFrom:	blapp.srcmap.SRCTYPE.CATALOG_ITEM
								,	idSrcFrom:		itemBasic.idItem
								};

		_.forEach( 
			this.renderData.view
		,	( inv ) =>
			{
				if ( inv._isSelected )
				{
					addItems.push(
						{
							dmItemImage:	inv.dmItem
						,	bNotify:		false
						,	idWantedItem:	null
						,	mMaxPrice:		0
						,	nHaveQty:		0
						,	nWantedColorId:	inv.dmItem.idColor
						,	nWantedQty:		inv.nQty
						,	strCondition:	"X"
						,	strRemarks:		"Added from " + blapp.util.getTypeName( itemBasic.typeItem ) + " " + itemBasic.strItemNoFull
						}						
					);
				}
			}
		);

		return (
			<AddToWantedListModal 
				data={addItems} 
				func={{toggleModal: () => this.setState( { showAddToWantedList: false } )}}
				srcmap={smi}
			/> 			
		)

	}

	renderEasyBuy()
	{
		const	itemBasic	= this.itemData.dmItemDetail.dmItem.dmBasic;
		let		fis			=[];

		_.forEach( 
			this.renderData.view
		,	( inv, idx ) =>
			{
				if ( inv._isSelected )
				{
					fis.push(
						{
							keyFind:	idx
						,	idItem:		inv.dmItem.dmItem.idItem
						,	idColor:	inv.dmItem.idColor
						,	nQty:		inv.nQty
						,	bMandatory:	false
						,	condNew:	"X"
						,	bSealed:	false
						}						
					);
				}
			}
		);		

		return (
			<EasyBuyModal 
				origin=""
				originName={ "From " + blapp.util.getTypeName( itemBasic.typeItem, false ) + " " + itemBasic.strItemNoFull }
				itemsToBuy={ fis }
				findOption={{op_only: true}}
				toggleModal={()=>this.setState({ showEasyBuy: false })}
				srcMap={
					{
						location:		blapp.srcmap.LOCATION.CATALOG_CONSISTS_OF_XP
					,	typeSrcFrom:	blapp.srcmap.SRCTYPE.CATALOG_ITEM
					,	idSrcFrom:		itemBasic.idItem
					}
				}
			/>			
		);
	}

	breakItems(type) {
		if(type == 'minifigs')
			this.setState({breakMinifigs : !this.state.breakMinifigs}, () => this.getInventory())
		else if( type == 'sets' )
			this.setState({breakSets : !this.state.breakSets}, () => this.getInventory())

	}

	getAlternates( item, type)
	{
		if( type == 0)
			return _.filter( this.invAlternates, ( inv ) => inv.idMatch == item.idMatch );
		else
			return _.filter( this.invData, ( inv ) => inv.idMatch == item.idMatch && inv.dmItem.dmItem.idItem != item.dmItem.dmItem.idItem );
	}

	toggleAlternate() {
		this.setState( { showAlternate: !this.state.showAlternate } );
	}

	toggleAllOfAll() 
	{
		_.forEach(
			this.renderData.view
		,	( inv ) =>
			{
				inv._isSelected	= !this.renderData.isAllSelected;
			}
		);

		this.setState( { dummy: this.state.dummy + 1 } );
	}

	toggleAll( type ) 
	{
		if ( type == "part" )
		{
			let	newVal	= !( this.renderData.pCnt == this.invParts.length );
			_.forEach( this.invParts, ( inv ) => { inv._isSelected = newVal } );
		}
		else if ( type == "minifig" )
		{
			let	newVal	= !( this.renderData.mCnt == this.invMinifigs.length );
			_.forEach( this.invMinifigs, ( inv ) => { inv._isSelected = newVal } );
		}
		else if ( type == "set" )
		{
			let	newVal	= !( this.renderData.sCnt == this.invSets.length );
			_.forEach( this.invSets, ( inv ) => { inv._isSelected = newVal } );
		}
		else if ( type == "alternates" )
		{
			let	newVal	= !( this.renderData.aCnt == this.invAlternates.length );
			_.forEach( this.invAlternates, ( inv ) => { inv._isSelected = newVal } );
		}
		else if ( type == "counterparts" )
		{
			let	newVal	= !( this.renderData.cCnt == this.invCounterparts.length );
			_.forEach( this.invCounterparts, ( inv ) => { inv._isSelected = newVal } );
		}
		else if ( type == "extras" )
		{
			let	newVal	= !( this.renderData.eCnt == this.invExtras.length );
			_.forEach( this.invExtras, ( inv ) => { inv._isSelected = newVal } );
		}
		this.setState( { dummy: this.state.dummy + 1} );
	}

	toggleInventorySelection(idx) 
	{
		if ( idx < this.invData.length )
		{
			this.invData[ idx ]._isSelected	= !this.invData[ idx ]._isSelected;
			this.setState( { dummy: this.state.dummy + 1 } );
		}
	}

	renderStickyFooter() 
	{
		return (
			<div ref={editingBar => this.editingBar = editingBar} className="product-inventory__sticky-footer">
				<div className="product-inventory__sticky-footer-internal-container">
					<div ref={editingBarInternal => this.editingBarInternal = editingBarInternal} className="product-inventory__sticky-footer-internal">
						<p className="product-inventory__sticky-footer-selected">
							{$T("N_ITEMS_SELECTED",[this.renderData.selectedCnt])}
						</p>
						<div className="product-inventory__sticky-footer-actions">
							<button className="btn btn--grey l-margin-right--sm l-full-width" onClick={(e)=>this.addToWanted()}><i className="far fa-heart l-margin-right--sm"/>Add to Wanted List</button>
							<button className="btn btn--cta-alt text--bold l-margin-left--sm l-full-width" onClick={(e)=>this.doEasyBuy()}><i className="fas fa-wand-magic-sparkles l-margin-right--sm"/>Easy Buy</button>
						</div>
					</div>
				</div>
			</div>
		);
	}

	initStickyEditBar() 
	{
		let editBarTop = 0;

		window.addEventListener(
			'scroll'
		,	() =>
			{
				if ( this.editingBar )
				{
					const editBar 				= this.editingBar;
					const editBarInternal	= this.editingBarInternal;
					const sidebar 				= this.sidebar;
					
					const editBarHeight 	= editBar.offsetHeight;
					const sidebarWidth 		= sidebar.offsetWidth;
					const currentScroll 	= Math.round(window.scrollY);


					if(editBarTop == 0) {
						editBarTop = editBar.offsetTop;
					}

					if ( currentScroll > editBarTop ) 
					{
						editBar.classList.add('product-inventory__sticky-footer--fixed');
						// editBarInternal.style.marginRight = sidebarWidth == 0 ? 0 : sidebarWidth + 35 + 'px';
					}
					else
					{
						editBar.classList.remove('product-inventory__sticky-footer--fixed');
						// editBarInternal.style.marginRight = '';
					}
				}							
			}
		);		
	}

	loadMore(){
		this.setState({page: this.state.page + 1});
	}

	updateSortType(newSortType) {
		newSortType	= parseInt( newSortType );

		if ( newSortType >= 0 )
		{
			this.setState( { fetchSerial: this.state.fetchSerial + 1, sortType: newSortType, sortDirection: ( newSortType == 1 || newSortType == 2 ) ? 1 : -1 } );
		}
	}

	toggleSortDirection() {
		let	newDirection	= ( this.state.sortDirection == -1 ) ? 1 : -1;

		this.setState( { fetchSerial: this.state.fetchSerial + 1, sortDirection: newDirection } );
	}

	getSortOrderInfo( idx ) {
		switch ( idx )
		{
		case 0:		return "Color, Part name"
		case 1:		return "Part name";
		case 2:		return "Part number";
		case 3:		return "Quantity";
		case 4:		return "Category";
		case 5:		return "Date added";
		case 6:		return "Date updated";
		case 7:		return "Known colors";
		case 8:		return "Appears In";
		case 9:		return "Parts count";
		case 10:	return "Minifigures count";
		case 11:	return "Available lots";
		default:	return "Color, Part name";
		}
	}

	sortBy = (a,b) =>
	{
		const dir = this.state.sortDirection;
		switch(this.state.sortType)
		{
			case 0: //Default (Color, Part Name)
				if(blapp.color.get(a.dmItem.idColor).strColorName < blapp.color.get(b.dmItem.idColor).strColorName){
					return -1 * dir;
				}
				else if(blapp.color.get(a.dmItem.idColor).strColorName > blapp.color.get(b.dmItem.idColor).strColorName){
					return 1 * dir;
				}
				else if(a.dmItem.dmItem.strItemName.toLowerCase() < b.dmItem.dmItem.strItemName.toLowerCase()){
					return -1 * dir;
				}
				else if(a.dmItem.dmItem.strItemName.toLowerCase() > b.dmItem.dmItem.strItemName.toLowerCase()){
					return 1 * dir;
				}
				return 0;
			case 1: //Part name
				if (a.dmItem.dmItem.strItemName.toLowerCase() > b.dmItem.dmItem.strItemName.toLowerCase()) {
					return 1 * dir;
				}
				else if (a.dmItem.dmItem.strItemName.toLowerCase() < b.dmItem.dmItem.strItemName.toLowerCase()) {
					return -1 * dir;
				}
				else{
					  return 0;
				}
			case 2: //Part number
				if (a.dmItem.dmItem.strItemNo > b.dmItem.dmItem.strItemNo) {
					return 1 * dir;
				}
				else if (a.dmItem.dmItem.strItemNo < b.dmItem.dmItem.strItemNo) {
					return -1 * dir;
				}
				else{
					return 0;
				}
			
			case 3: //Quantity
				return (a.nQty - b.nQty) * dir;
			case 4: //Category
				if (this.getCategory(a) > this.getCategory(b)) {
					return 1 * dir;
				}
				else if (this.getCategory(a) < this.getCategory(b)) {
					return -1 * dir;
				}
				else{
					return 0;
			}
		}
	}

	getCategory(inv)
	{
		let cat = "";
		if( inv.dmItem.dmItem.strCatStrV2 && inv.dmItem.dmItem.strCatStrV2 != '')	
			cat = blapp.category.getV2ListByCatStr(inv.dmItem.dmItem.strCatStrV2).map(c => c.strName).join(',')
		else
			cat = blapp.util.decodeHtml(blapp.category.getLegacy(inv.dmItem.dmItem.strCatStr).strCategoryName)
		return cat;
	}

	addToWanted()
	{
		this.setState( { showAddToWantedList: true } );
	}

	doEasyBuy()
	{
		this.setState( { showEasyBuy: true } );

	}

	getInventory()
	{
		let typeBreak = 0;
		if( this.state.breakMinifigs && !this.state.breakSets )
			typeBreak = 1;
		else if( !this.state.breakMinifigs && this.state.breakSets )
			typeBreak = 2
		else if( this.state.breakMinifigs && this.state.breakSets )
			typeBreak = 3

		blapp.models.fetch(
			"_getConsistOf"
		,	{
				controller:	"catalog.BLCCatalogItemInv"
			,	method:		"getConsistOf"
			,	params:		[blapp.util.getUrlVar( "idItem" ), blapp.util.getUrlVar( "idColor" ), typeBreak]
			,	refresh:	true
			}
		).then(
			( data ) =>
			{
				this.invData = data
				this.buildInfo(true);
			}
		).catch ( 
			( error ) =>
			{
				console.log("Error obtaining inventory: "+ error)
			}
		);
	}
}

document.addEventListener( "DOMContentLoaded", 
	function() {
		var	elem	=	ReactDOM.render(
							<ItemInventoryPage blctx={{parent: null, idx:0}} />
						,	document.getElementById( 'bl-item-inventory-page' )
						);
		blapp.refs.register( "main", elem );
	}
);

var $T = BLComponent.createTextMap(
	{
		"DATA_NOT_FOUND":
		{
			"en":	"Data Not Found!"
		,	"es":	"Información no encontrada!"
		}
	,	"BACK_TO_ITEM_DETAILS":
		{
			"en":	"Back to item details"
		,	"es":	"Volver a detalles del producto"
		}
	,	"CONSISTS_OF":
		{
			"en":	"consists of"
		,	"es":	"consiste de"
		}
	,	"SORT_BY":
		{
			"en":	"Sort by:"
		,	"es":	""
		}
	,	"ALL_ITEMS":
		{
			"en":	"All items"
		,	"es":	"Todos los productos"
		}
	,	"SETS":
		{
			"en":	"Sets"
		,	"es":	"Sets"
		}
	,	"MINIFIGS":
		{
			"en":	"Minifigures"
		,	"es":	"Minifigures"
		}
	,	"PARTS":
		{
			"en":	"Parts"
		,	"es":	"Partes"
		}
	,	"DESELECT_ALL":
		{
			"en":	"Deselect all"
		,	"es":	"Deseleccionar todo"
		}
	,	"SELECT_ALL":
		{
			"en":	"Select all"
		,	"es":	"Seleccionar todo"
		}
	,	"N_ITEMS_SELECTED":
		{
			"en":	"{{$0?s=( item):( items)}} selected"
		,	"es":	"{{$0?s=( producto seleccionado):( productos seleccionados)}}"
		}
	}
);